import type { RouteObject } from 'react-router-dom'

import type { NavItem } from '@/app/registry'

import { ConsentPage } from './ConsentPage'

// После входа, без оболочки: полноэкранная страница согласия OAuth.
export const bareRoutes: RouteObject[] = [{ path: '/oauth/consent', element: <ConsentPage /> }]

export const routes: RouteObject[] = []
export const nav: NavItem[] = []
